module.exports = __webpack_public_path__ + "static/media/photo-album.bd0ecb27.svg";